import React, {useState} from 'react';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from "primereact/dropdown";
import { LookupField } from '../../../components/lookup/LookupField';
import '../../../index.scss'
import FileUploaderButton from '../../../components/file-uploader-button/FileUploaderButton';
import { InputSwitch } from 'primereact/inputswitch';
import * as IconFactory from "../../../services/icons.factory";

export const TrackingFilter = (props) => {

    //controla o span do botão compartilhar
    const [showOptions, setShowOptions] = useState(false);

    const handleButtonClick = () => {
        setShowOptions(!showOptions); 
    };

    const btnInputXLSX = React.useRef(null);
    const importField = () => {
        // btnInputXLSX.current.value = "";
        btnInputXLSX.current.click(props.downloadHandler)
    }
    const onChangeFile = (e) => {
        props.importFile(e)
        btnInputXLSX.current.value = "";
    }


 const getTruckStatusIconLabel = (status) => {
      let truckIcon = null;
      let title = "";
      switch (status) {
        case "IN_TIME":
          truckIcon = IconFactory.getIcon("truck_normal", false);
          title = "No prazo";
          break;
        case "ON_TIME":
          truckIcon = IconFactory.getIcon("truck_warning", false);
          title = "Prazo vence hoje";
          break;
        case "LATE":
          truckIcon = IconFactory.getIcon("truck_failure", false);
          title = "Prazo vencido";
          break;
        case "DELIVERED_LATE":
          truckIcon = IconFactory.getIcon("truck_success_pending", false);
          title = "Entregue fora do prazo";
          break;
        case "DELIVERED_IN_TIME":
          title = "Entregue no prazo";
          truckIcon = IconFactory.getIcon("truck_success", false);
          break;
        case "DELIVERY_CANCELED":
          title = "Pedido cancelado";
          truckIcon = IconFactory.getIcon("truck_canceled", false);
          break;
        case "BAIXA_MANUAL":
          title = "Baixado manual";
          truckIcon = IconFactory.getIcon("truck_blue_border", false);
          break;
        default:
          truckIcon = IconFactory.getIcon("truck_normal", false);
          break;
      }
      return {
        icon: truckIcon,
        title: title,
      };
    };

    const statusFilter = () => {
    
        const deliveryStatusOptions = props.deliveryStatusOptions.map(
            (option, index) => {

                const randomNumber = Math.floor(Math.random() * 1000)

                const iconObj = getTruckStatusIconLabel(option.value);

                const key = `{${option.value}-${randomNumber}}`;

                return {
                value: option.value,
                label: !option.value ? (
                    "TODOS"
                ) : (
                    <div 
                        className="lxTruck_status" 
                        key={key}
                        style={{
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'flex-start', 
                        }}
                    >
                    {" "}
                    <img
                        src={iconObj.icon}
                        alt={option.label}
                        title={option.label}
                        style={{marginRight: '15px'}}
                    />
                    
                    <span>{option.label}</span>
                    {" "}
                    </div>
                ),
                };
            }
        );

        const randomNumber = Math.floor(Math.random() * 1000)

        return (
        <Dropdown
            style={{ width: "100%" }}
            key={`${randomNumber}-DesliveryStatus`}
            value={props.currentFilterDeliveryStatus}
            options={deliveryStatusOptions}
            onChange={props.handleChangeDeliveryStatus}
        />
        );
    }

    return (
        <div className="carrier-form">
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="p-grid">
                        <div className="p-col-2 form-field-container">
                            <label>Nota Fiscal</label>
                            <InputText value={props.nfeNumberFilter ? props.nfeNumberFilter : ""} onChange={props.nfeNumberChangeHandler} name="nfeNumberFilter" />
                        </div>
                        {/* <div className="p-col-2 form-field-container">
                            <label>Campos Customizados</label>
                            <InputText value={props.customFields ? props.customFields : ""} onChange={props.customFieldChangeHandler} name="customFields" />
                        </div>
                        <div className="p-col-2 form-field-container" style={{
                            display: "flex",
                            justifyContent: "center"
                        }}>
                            <label>Contém</label>
                            <InputSwitch checked={props.containCustomField} onChange={props.changeContainCustomField} name="containCustomField" />
                        </div> */}



                    </div>
                    <div className="p-grid">
                        <div className="p-col-2 form-field-container">
                            <label className="lxRequiredField">De</label>
                            <Calendar showIcon={true} value={props.initialDateFilter} showTime={false} onChange={props.initialDateChangeHandler} disabled={false} name="initialDateFilter" dateFormat="dd/mm/yy" />
                        </div>
                        <div className="p-col-2 form-field-container">
                            <label className="lxRequiredField">Até</label>
                            <Calendar showIcon={true} value={props.finalDateFilter} showTime={false} onChange={props.finalDateChangeHandler} disabled={false} name="finallDateFilter" dateFormat="dd/mm/yy" />
                        </div>
                        <div className="p-col-2 form-field-container">
                            <label>Transportadora</label>
                            <LookupField
                                value={props.carrierFilter ? props.carrierFilter : null}
                                placeholder="Transportadora"
                                name="tradeName"
                                field="tradeName"
                                onComplete={props.lookupCarrierOnComplete}
                                onInputFilter={props.lookupCarrierOnInputFilter}
                                editDisabled={props.lookupCarrier.editDisabled}
                                onEditField={props.lookupCarrierOnEdit}
                                onClick={props.lookupCarrierOnClick}
                                visible={props.lookupCarrier.visible}
                                modal={props.lookupCarrier.modal}
                                header={props.lookupCarrier.header}
                                onHide={props.lookupCarrierOnHide}
                                onConfirm={props.lookupCarrierOnConfirm}
                                onCancel={props.lookupCarrierOnCancel}
                                records={props.lookupCarrier.records}
                                columns={props.lookupCarrier.columns}
                                totalRecords={props.lookupCarrier.totalRecords}
                                sortOrder={props.lookupCarrier.order}
                                sortField={props.lookupCarrier.sortField}
                                first={props.lookupCarrier.first}
                                rows={props.lookupCarrier.rows}
                                onPage={props.lookupCarrierOnPage}
                                onFilter={props.lookupCarrierOnFilter}
                                onSort={props.lookupCarrierOnOnSort}
                                paginator={props.lookupCarrier.paginator}  
                                emptyMessage="Não foram encontrados registros"
                                rowsPerPageOptions={props.lookupCarrier.rowsPerPageOptions}
                            />
                        </div>
                        <div className="p-col-2 form-field-container">
                            <label>Status</label>
                                {statusFilter()}
                            {/* <Dropdown
                                style={{ width: "100%" }}
                                key={`${field}-DesliveryStatus`}
                                value={props.currentFilterDeliveryStatus}
                                options={deliveryStatusOptions}
                                //onChange={this.handleChangeDeliveryStatus}
                            /> */}

                            {/* <Dropdown
                                style={{ width: "100%" }}
                                name={"totalOccurrences"}
                                key={'k1'}
                                value={props.totalOccurrencesFilter}
                                options={props.totalOccurrencesOptions}
                                onChange={props.totalOccurrencesChangeHandler}
                            /> */}
                        </div>
                        <div className="p-col-1 form-field-container">
                            <br />
                            <button
                                className="lognex-btn-highlighted"
                                style={{ width: "100%" }}
                                title="Filtrar"
                                onClick={props.applyTrackingFilter}>
                                Filtrar
                            </button>
                        </div>
                        <div className="p-col-1 form-field-container">
                            <br />
                            <button
                                className="lognex-btn-highlighted-inverse"
                                style={{ width: "100%" }}
                                title="Download"
                                onClick={props.onDownloadCSV}
                                disabled={!props.enabledExportCSV}
                            >
                                Exportar
                            </button>
                        </div>
                        <div className="p-col-1 form-field-container" style={{ position: 'relative' }}>
                            <br />
                            <button
                                className="lognex-btn-highlighted-inverse"
                                style={{ width: "100%" }}
                                title="Compartilhar"
                                onClick={handleButtonClick}
                                disabled={false}
                            >
                                Compartilhar
                            </button>

                            {showOptions && (
                                <span
                                    className="share-options" 
                                    style={{                                        
                                        position: 'absolute', 
                                        top: '100%', 
                                        left: '12',
                                        zIndex: '999', 
                                        marginTop: '5px',
                                        border: '1px solid #ccc', 
                                        borderRadius: '5px', 
                                        padding: '10px', 
                                        backgroundColor: '#fff', 
                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <button 
                                        className="lognex-btn-highlighted-inverse" 
                                        onClick={() => console.log('Compartilhar por WhatsApp')}
                                        title="Compartilhar no WhatsApp"
                                        style={{
                                            width: '100%', 
                                            marginBottom: '10px', 
                                        }}
                                    >
                                        {/* <i className="pi pi-whatsapp" style={{ marginRight: '5px' }} ></i> */}
                                        WhatsApp
                                    </button>
                                    <button 
                                        style={{
                                            width: '100%', 
                                        }}
                                        className="lognex-btn-highlighted-inverse" 
                                        onClick={() => console.log('Compartilhar por Email')}
                                        title="Compartilhar por E-mail"
                                    >
                                        {/* <i className="pi pi-envelope" style={{ marginRight: '5px' }} ></i> */}
                                        E-mail
                                    </button>
                                </span>
                            )}

                        </div>
                        {/* <div className="p-col-1 form-field-container">
                            <br />
                            <button
                                className="lognex-btn-highlighted-inverse"
                                style={{ width: "100%" }}
                                title="Enviar Arquivo"
                                onClick={importField}
                                disabled={false}
                            >

                                <i className="pi pi-upload"></i>
                                <input type='file' style={{ display: "none" }} ref={btnInputXLSX} onChange={onChangeFile} />
                            </button>
                        </div> */}
                    </div>


                </div>
            </div>
        </div>
    );
}
